<template>
  <div class="canvasListWarp">
    <div class="listTop">
      文档共{{page_count}}页
    </div>
    <div class="canvasList">
      <div class="canvasBox canvasstyle" v-for="(n,index) in page_count":class="{active:n==nowPage}">
        <div class="canvasStatus" :class="listStatus[index]==2?'canvasSuccess':'canvasErro'" v-if="listStatus[index]!=''"></div>
        <canvas :id="'canvas' + n" @click="emitIndex(n)"></canvas>
        <div class="jb">{{n}}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import PDFJS from 'pdfjs-dist'
  import {mapActions, mapGetters} from 'vuex';
  const CMAP_URL = 'https://unpkg.com/pdfjs-dist@2.0.489/cmaps/';
  export default {
    name: 'c-pdf',
    props:['pdfUrl','nowPage',"canvasQzList","nowType"],
    components:{},
    data() {
      return {
        pdfDoc: null, //pdfjs 生成的对象
        pageRendering: false,
        scale: 1,//放大倍数
        page_count: 0,//总页数
      }
    },
    methods: {
      renderPage(num) { //渲染pdf
        let vm = this;
        for(let i = 1;i<=this.page_count;i++){
          this.pageRendering = true;
          let canvas = document.getElementById('canvas' + i);
          this.pdfDoc.getPage(i).then(function(page) {
            let viewport = page.getViewport(vm.scale);
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            let renderContext = {
              canvasContext: canvas.getContext('2d'),
              viewport: viewport
            };
            let renderTask = page.render(renderContext);
          });
          }
        },
      emitIndex(index){
        this.$emit('changePage',index);
      }
    },
    computed: {
      listStatus(){
        let ars = [],
          _this = this;
        this.canvasQzList.forEach((item,index)=>{
          let e = '';
          if(item.qzList.length>0){
            item.qzList.forEach((it,inds)=>{
              if(_this.nowType == it.type){
                e = 1;
                if(it.sindImg&&it.signId){
                  e = 2;
                }
              }
            })
          }
          ars.push(e)
        });
        return ars;
      }
    },
    mounted() {
      let vm = this;
      PDFJS.getDocument({
        url: vm.pdfUrl,
        cMapUrl: CMAP_URL,
        cMapPacked: true,
      }).then(function(pdfDoc_) { //初始化pdf
        vm.pdfDoc = pdfDoc_;
        vm.$emit('allNum',pdfDoc_.numPages);
        vm.page_count = vm.pdfDoc.numPages;
       setTimeout(function () {
         vm.renderPage();
       },1)
      });
    }
  }

</script>
<style type="text/less" lang="less" rel="stylesheet/less" scoped="scoped">
  .canvasListWarp{
    width: 279px;
    position: fixed;
    right: 0;
    top:0;
    bottom: 0;
    box-shadow: -5px 0px 15px rgba(0,0,0,0.1);
    .listTop{
      line-height: 75px;
      text-align: center;
      font-size: 10px;
      background: #ffffff;
      border-bottom: 1px solid #EFEFEF;
    }
    .canvasList {
      text-align: center;
      overflow: hidden;
      overflow-y: scroll;
      width: 100%;
      float: right;
      position: absolute;
      right: 0;
      top: 76px;
      bottom: 0;
      padding-bottom: 50px;
      background: #FDFEFE;
      .canvasstyle{
        display: block;
        margin: 0 auto;
        margin-top: 30px;
        border: 1px solid #cccccc;
        width: 200px;
        height: 240px;
        position: relative;
        .canvasStatus{
          width: 55px;
          height: 55px;
          position: absolute;
          right: 0px;
          top: 0;
          background-size: 100% 100%;
        }
        .canvasSuccess{
          background:url("../../assets/images/label_complete.png");
        }
        .canvasErro{
          background:url("../../assets/images/label_unfinished.png");
        }
        .jb{
          width: 20px;
          height: 20px;
          position: absolute;
          left: 0;
          bottom: 0;
          background: #CACACA;
          color: #ffffff;
          font-size: 12px;
          line-height: 20px;
        }
        &.active{
          border-color: #2359BE;
          .jb{
            background: #2359BE;
          }
        }
        canvas{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/fire/pdfTest.vue